module.exports = __webpack_public_path__ + "img/arrow-down.11b9426d.svg";